import * as Blockly from 'blockly/core';
import 'blockly/python';
//import {getAllowedOutputs} from "./strata_compatibility_checks";
import createCustomThresholdFields from "../strata/strata_custom_threshold_fields";

Blockly.Blocks['globe_sat'] = {
    init: function() {
      this.appendDummyInput()
          .setAlign(Blockly.ALIGN_LEFT)
          .appendField("Indicator   ")
          .appendField(new Blockly.FieldDropdown([
            ["RADAR change VV ascending", "VVa"],
            ["RADAR change VV descending", "VVd"],
            ["RADAR change VH ascending", "VHa"],
            ["RADAR change VH descending", "VHd"],
          ]), "indicator_selection");

      createCustomThresholdFields(this);
      
      this.setPreviousStatement(true, 'globe_sat');
      this.setNextStatement(true);
      this.setStyle('comparison');
      this.setTooltip("");
      this.setHelpUrl("");
    }
  }
